import * as React from "react";
import { StackSection, Stack, Hidden } from "@origin-digital/ods-core";
import { EmbeddedContent } from "@origin-digital/tal-fe";
import { LoginViewMessagesController } from "../components/LoginViewMessages";
import { IAppContext } from "../AppContext";
import { SlimCard } from "../components/Personalisation";
import { usePrefetched } from "../helpers/usePrefetched";
import { ScreenTemplate } from "./ScreenTemplate";

interface IProps {
  context: IAppContext;
}

export const Home = ({ context }: IProps) => {
  const sectionPrefetchedContent = usePrefetched("quickLinks");

  return (
    <ScreenTemplate isHome={true} data-id="home">
      <StackSection backgroundColor="white" width="full">
        <Stack space={["large", "xlarge"]}>
          <SlimCard />
          {sectionPrefetchedContent?.content ? (
            <EmbeddedContent content={sectionPrefetchedContent.content} />
          ) : null}
          {!context.isNative && (
            <Hidden above="lg">
              <Stack space={["large", "xlarge"]}>
                <LoginViewMessagesController />
              </Stack>
            </Hidden>
          )}
        </Stack>
      </StackSection>
    </ScreenTemplate>
  );
};
